























import Component, { mixins } from 'vue-class-component';

import FormBase from '@/general/abstract/form/FormBase.vue';
import { VModel } from 'vue-property-decorator';

import { CalculationApi } from '@/context/calculation/api/CalculationApi';
import _ from 'lodash';
import { AnomalyRemovalFormModel } from '@/context/calculation/model/AnomalyRemovalFormModel';
import AnomalyRemovalFormTemplate
  from '@/context/calculation/components/AnomalyRemovalFormTemplate.vue';
import { AxiosResponse } from 'axios';
import { AnomalyRemovalResponse } from '@/context/calculation/model/AnomalyRemovalResponse';
import { notNullOrUndefined } from '@/utility/functions';
import Form from '@/general/abstract/form/mixin/Form';

@Component({
  components: {
    AnomalyRemovalFormTemplate,
    FormBase
  }
})
export default class AnomalyRemovalForm extends mixins<
  Form<AnomalyRemovalFormModel, AnomalyRemovalFormModel, AnomalyRemovalResponse>
>(Form) {
  @VModel({ default: new AnomalyRemovalFormModel() }) model!: AnomalyRemovalFormModel;
  response = new AnomalyRemovalResponse(0);
  responseAlertActive: boolean = false;
  responseErrorAlertActive: boolean = false;
  buildCmd(): AnomalyRemovalFormModel {
    let command: AnomalyRemovalFormModel = Object.assign<
      AnomalyRemovalFormModel,
      AnomalyRemovalFormModel
    >(new AnomalyRemovalFormModel(), _.omit(this.model, "customer", "facilities"));
    return command;
  }

  async submitApi(cmd: AnomalyRemovalFormModel): Promise<AnomalyRemovalResponse> {
    this.responseAlertActive = false;
    this.responseErrorAlertActive = false;
    cmd.start += "T00:00:00";
    cmd.end += "T00:00:00";
    let command: AnomalyRemovalFormModel = Object.assign<
      AnomalyRemovalFormModel,
      AnomalyRemovalFormModel
    >(
      new AnomalyRemovalFormModel(),
      _.omit(cmd, "customer", "facilities", "anomaliesRemovedCount")
    );
    const model: AxiosResponse<AnomalyRemovalResponse> = await CalculationApi.instance().anomalyRemoval(
      command
    );
    return Promise.resolve(model.data);
  }

  async navigateAfterResponse(model: AnomalyRemovalResponse): Promise<void> {
    console.log(model);
    if (notNullOrUndefined(model)) {
      this.response.anomaliesRemovedCount = model.anomaliesRemovedCount;
      this.responseAlertActive = true;
    }
  }
  setErrors(errors: AxiosResponse): void {
    this.responseErrorAlertActive = true;
  }
}
